import { render, staticRenderFns } from "./MultipleSoalForm.vue?vue&type=template&id=b75ad1b8"
import script from "./MultipleSoalForm.vue?vue&type=script&lang=js"
export * from "./MultipleSoalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports